import React from "react";
import { Box } from "@mui/material";
import { PRIMARY_ORANGE } from "./constants";

const variants = {
  orange: {
    border: `1px solid ${PRIMARY_ORANGE}`,
    color: PRIMARY_ORANGE,
    bgcolor: "#fff3e8",
  },
  grey: {
    border: "1px solid #e0e0e0",
    color: "#666",
    bgcolor: "#f5f5f5",
  },
  green: {
    border: "1px solid #66bb6a",
    color: "#2e7d32",
    bgcolor: "#e8f5e9",
  },
  red: {
    border: "1px solid #ef5350",
    color: "#c62828",
    bgcolor: "#ffebee",
  },
  blue: {
    border: "1px solid #42a5f5",
    color: "#1565c0",
    bgcolor: "#e3f2fd",
  },
};

export const getStatusVariant = (status) => {
  const normalized = String(status || "").toLowerCase();

  if (!status) return "grey";
  if (normalized.includes("pending") || normalized.includes("unverified")) return "orange";
  if (
    normalized.includes("approve") ||
    normalized.includes("verified") ||
    normalized.includes("active") ||
    normalized.includes("complete") ||
    normalized.includes("success")
  ) {
    return "green";
  }
  if (
    normalized.includes("reject") ||
    normalized.includes("expired") ||
    normalized.includes("suspend") ||
    normalized.includes("disable") ||
    normalized.includes("cancel")
  ) {
    return "red";
  }
  if (normalized.includes("manual")) return "blue";

  return "grey";
};

export const formatStatusLabel = (status) => {
  if (!status) return "N/A";
  const text = String(status);
  if (text === text.toUpperCase()) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const TableStatusBadge = ({ label, variant }) => {
  const resolvedLabel = label ?? "N/A";
  const resolvedVariant = variant || getStatusVariant(resolvedLabel);

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 1.25,
        py: 0.35,
        borderRadius: "20px",
        fontSize: "0.75rem",
        fontWeight: 600,
        whiteSpace: "nowrap",
        ...variants[resolvedVariant],
      }}
    >
      {resolvedLabel}
    </Box>
  );
};

export const PendingApprovalBadge = ({ pending }) => (
  <TableStatusBadge
    label={pending ? "Pending" : "Approve"}
    variant={pending ? "orange" : "green"}
  />
);

export const ActiveStatusBadge = ({ active }) => (
  <TableStatusBadge
    label={active ? "Active" : "Inactive"}
    variant={active ? "green" : "grey"}
  />
);

export default TableStatusBadge;
